import baseAPI from '@/api/base';
import { GetCalendarHolidays, GetHolidays, RegisterCalendarHoliday, RemoveHoliday } from '@/dtos/holiday.dto';
import {
  CHECK_HOLIDAY_URL,
  GET_CALENDAR_HOLIDAY_URL,
  GET_HOLIDAY_URL,
  REGISTER_CALENDAR_HOLIDAY_URL,
  REMOVE_HOLIDAY_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class Holiday {
  static getCalendarHolidays = async (getCalendarHolidays: GetCalendarHolidays): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_CALENDAR_HOLIDAY_URL, {
      params: getCalendarHolidays,
    });
    console.log('response', response);
    return response;
  };

  static registerCalendarHoliday = async (registerCalendarHoliday: RegisterCalendarHoliday): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_CALENDAR_HOLIDAY_URL, {
      ...registerCalendarHoliday,
    });
    console.log('response', response);
    return response;
  };

  static getHolidays = async (getHolidays: GetHolidays): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_HOLIDAY_URL, {
      params: getHolidays,
    });
    console.log('response', response);
    return response;
  };

  static checkHoliday = async (getHolidays: GetHolidays): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(CHECK_HOLIDAY_URL, {
      params: getHolidays,
    });
    console.log('response', response);
    return response;
  };

  static removeHoliday = async (removeHoliday: RemoveHoliday): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(REMOVE_HOLIDAY_URL, {
      ...removeHoliday,
    });
    console.log('response', response);
    return response;
  };
}

export default Holiday;
